import { render, staticRenderFns } from "./Notifi.vue?vue&type=template&id=7e66006e&"
import script from "./Notifi.vue?vue&type=script&lang=js&"
export * from "./Notifi.vue?vue&type=script&lang=js&"
import style0 from "./Notifi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports